export default "__VITE_ASSET__OWkgmQpN__"